import { endMailSession, useMailStore } from '@/stores/mail'
import { resetMailViewQueue, useMailViewStore } from '@/stores/mailView'
import { clearCollapsed } from '@/views/mails/client/lib/folderView'

/**
 * Ends the mail module's session state: on logout and on an account switch the next session in
 * the same tab must not see the previous user's hidden folders, mailbox connections (with their
 * addresses), the open message or the folder collapse state, and must not receive answers or
 * queued preference saves the previous session started.
 */
export function resetMailSession(): void {
  resetMailViewQueue()
  endMailSession()
  useMailViewStore().$reset()
  useMailStore().$reset()
  clearCollapsed()
}
